import ActiveGlobalFilterIcon from './component'

export default ActiveGlobalFilterIcon
